import {getUserInfo, removeUserInfo, setUserInfo} from '../../utils/auth'
const UserList = {
  'admin': {
    token: 'admin-token',
    role: 'admin',
    avatar: 'https://s1.ax1x.com/2020/04/28/J5hUaT.jpg',
    name: 'admin',
    password: 'jh123456'
  }
}

const state = {
  currentUser: getUserInfo()
}
const mutations = {
  SET_CURRENT_USER: (state, currentUser) => {
    console.log('currentUser = ', currentUser)
    state.currentUser = currentUser
  }
}

const actions = {
  login({ commit }, {username, password}) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        let tempUser = UserList[username]
        if (password === tempUser.password) {
          commit('SET_CURRENT_USER', tempUser)
          setUserInfo(tempUser)
        } else {
          commit('SET_CURRENT_USER', null)
        }
        resolve()
      }, 2000)
    })
  },
  logout({ commit }) {
    console.log('退出登录')
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        removeUserInfo()
        commit('SET_CURRENT_USER', null)
        resolve()
      }, 2000)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js